import React from 'react';

import {YesNoFilter} from './generic-yes-no.filter';

type Props = {
    value?: boolean,
    onChange: (value?: boolean) => void,
};

export const IntegrationFilter = ({value, onChange}: Props) => (
    <YesNoFilter value={value} onChange={onChange} label="Integration Enabled"/>
);
